import { Money } from '../utils/money.model';

export interface LabourCosts {
  averageNettoSalaryPerHour: Money;
  socialCostsFactor: number; // percentage 0-100
  lastModifiedById?: string;
  lastModified?: Date;
}

export const labourCostsChatbotFields = {
  averageNettoSalaryPerHour: {
    type: 'object',
    description: 'Average netto salary per hour. Contains amount and currency. Only set if the intent is to change it.',
    properties: {
      amount: { type: 'number', description: 'The monetary amount' },
      currency: { type: 'number', description: 'The currency enum value' },
    },
  },
  socialCostsFactor: {
    type: 'number',
    description: 'Social costs factor as a percentage (0-100). Only set if the intent is to change it.',
  },
};
